/**
 * Defines a custom recorder and its controls which forward buffer as messages (from worker)
 */

export class CustomRecorder extends AudioWorkletNode {
  private _context: AudioContext;

  constructor(context) {
    super(context, 'audio-recorder', { // Configured to work in mono
      numberOfInputs: 1,
      numberOfOutputs: 1,
      outputChannelCount: [1]
    });

    this._context = context;
  }

  public start() {
    const param = this.parameters.get('isRecording');
        param?.setValueAtTime(1, this._context?.currentTime);
  }

  public stop() {
    const param = this.parameters.get('isRecording');
        param?.setValueAtTime(0, this._context?.currentTime);
  }
}